import { render, staticRenderFns } from "./TaxClientWrapContent.vue?vue&type=template&id=3c1dedc3&scoped=true&"
import script from "./TaxClientWrapContent.vue?vue&type=script&lang=js&"
export * from "./TaxClientWrapContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1dedc3",
  null
  
)

export default component.exports